import ProvidentFundReportView from '../components/ProvidentFundReportView';
export default function ProvidentFundBusinessReport(){return <ProvidentFundReportView key="business" reportKind="business"/>;}
